import PropTypes from 'prop-types';
import { useGetLegalEntityNames } from '@/shared/hooks/legalEntity/useGetLegalEntityNames';
import AuthService from '@/shared/services/AuthService';

export const useHasMultipleLegalEntities = () => {
  const hasFeature = AuthService.hasFeature('TenantMoore');
  const { data } = useGetLegalEntityNames();
  if (!hasFeature) return false;
  return Array.isArray(data) && data.length > 1;
};

const HasMultipleLegalEntities = ({ children = null, fallback = null }) => {
  const hasFeature = AuthService.hasFeature('TenantMoore');
  const { data, isLoading } = useGetLegalEntityNames();
  if (!children) return null;
  if (!hasFeature) return fallback;
  if (isLoading) return fallback;
  if (!Array.isArray(data) || data.length <= 1) return fallback;
  return children;
};

HasMultipleLegalEntities.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.node,
};

export default HasMultipleLegalEntities;
